import React from "react";
import { getValue } from "@utils/lodash";

function OrganizationInformationSvgComponent(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
        <defs>
            <clipPath id="clip-path-org-info">
            <rect id="Rectangle_18165" data-name="Rectangle 18165" width="18" height="18" transform="translate(-12028 -5424)" fill="#fff"/>
            </clipPath>
        </defs>
        <g id="Group_10474" data-name="Group 10474" transform="translate(-987 -212)">
            <g id="Group_10465" data-name="Group 10465">
            <circle id="Ellipse_3665" data-name="Ellipse 3665" cx="20" cy="20" r="20" transform="translate(987 212)" fill="#f3e8fc"/>
            <g id="Mask_Group_273" data-name="Mask Group 273" transform="translate(13026 5647)" clip-path="url(#clip-path-org-info)">
                <path id="corporate_fare_FILL0_wght300_GRAD0_opsz24" d="M2.21-6.045v-13.5H9.6v3.086h7.6V-6.045h-15ZM3.377-7.2h5.06V-9.131H3.377V-7.2Zm0-3.086h5.06v-1.929H3.377v1.929Zm0-3.086h5.06V-15.3H3.377v1.929Zm0-3.086h5.06v-1.929H3.377v1.929ZM9.6-7.2h6.437v-8.1H9.6v8.1Zm1.707-5.014v-1.157h2.874v1.157Zm0,3.086v-1.157h2.874v1.157Z" transform="translate(-12028.71 -5402.205)" fill="#8339cb"/>
            </g>
            </g>
        </g>
    </svg>
  );
}

export default OrganizationInformationSvgComponent;
